import React from "react";
import MomentUtils from '@date-io/moment';
import {DatePicker, MuiPickersUtilsProvider} from '@material-ui/pickers';
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/CloseRounded";
import './style.scss'
import moment from 'moment';

export default function UserDetailDateField(props) {
    function onFieldValueChange(newValue) {
        if (props.onFieldValueChange) {
            const clonedDate = new Date(newValue);
            clonedDate.setHours(0);
            clonedDate.setMinutes(0);
            clonedDate.setSeconds(0);

            props.onFieldValueChange(clonedDate.toISOString());
        }
    }

    function onClearSelectClicked() {
        if (props.onFieldValueChange)
            props.onFieldValueChange(undefined);
    }

    if (props.isEditEnabled)
        return (
            <div className="user-detail-date-field">
                {
                    props.isRequired && !props.value ?
                        <div className="user-detail-input-required-sign">*</div>
                        :
                        null
                }
                <MuiPickersUtilsProvider utils={MomentUtils}>
                    <DatePicker
                        className="user-detail-input"
                        error={props.isError}
                        placeholder={props.displayName}
                        value={props.value || null}
                        format="DD/MM/YYYY"
                        onChange={onFieldValueChange}
                        okLabel="בחר"
                        cancelLabel="בטל"
                        animateYearScrolling={true}
                    />
                </MuiPickersUtilsProvider>
                {
                    props.value ?
                        <div className="clear-select-button-wrapper">
                            <IconButton className="clear-select-button"
                                        onClick={onClearSelectClicked}
                                        size="small">
                                <CloseIcon fontSize="small"/>
                            </IconButton>
                        </div>
                        :
                        null
                }
            </div>
        );

    return (
        <React.Fragment>
            {moment(new Date(props.value)).format('DD/MM/YYYY')}
        </React.Fragment>
    );
}